
<!-- <router-outlet> {{ message | json }} </router-outlet> -->
<router-outlet> </router-outlet>